<template>
  <section>
    <div id="subHeader">
      <h1>Contactos</h1>
      <h2>fale connosco</h2>
    </div>
    <div class="container-fluid" id="main">
      <div class="row">
        <div class="col-md-6 p-5" id="info">
          <div class="row mb-3">
            <div class="col" style="flex-grow: 0;">
              <img alt="" src="/images/morada.png">
            </div>
            <div class="col">Av. República 2208 8 drt rec trz,<br><span>4430-196 Vila Nova de Gaia</span></div>
          </div>
          <div class="row my-5">
            <div class="col" style="flex-grow: 0;">
              <img alt="" src="/images/envelope-email-sgg.png">
            </div>
            <div class="col align-content-center">geral@sggtoc.com </div>
          </div>
          <div class="row">
            <div class="col" style="flex-grow: 0;">
              <img alt="" src="/images/telefone.png">
            </div>
            <div class="col m-auto">
              <ul class="p-0 m-0 list-unstyled">
                <li>
                  +351 223 745 214
                  <br/><small class="pl-3">( Chamada para a rede fixa nacional. )</small>
                </li>
                <li>
                  +351 223 745 215
                  <br/><small class="pl-3">( Chamada para a rede fixa nacional.) </small>
                </li>
                <li>
                  +351 918 903 547
                  <br/><small class="pl-3">( Chamada para a rede móvel nacional. )</small>
                </li>
                <li>
                  +351 928 115 639
                  <br/><small class="pl-3">( Chamada para a rede móvel nacional. )</small>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <form @submit.prevent="submit" class="col-md-6 p-5">
          <input class="form-control" placeholder="Nome" type="text" v-model="name">
          <input class="form-control" placeholder="E-mail" type="text" v-model="email">
          <textarea class="form-control" placeholder="Mensagem" rows="3" v-model="msg"></textarea>
          <div class="w-100 text-right">
            <button class="btn" id="send-btn">Enviar Mensagem</button>
          </div>
        </form>
      </div>
      <div class="map">
        <iframe
            :src="`https://www.google.com/maps/embed/v1/place?key=AIzaSyCN9YKWPZh_VNcRFV8lUT11cYJhj0kIg1w&q=${encodeURIComponent('Av. República 2208 8 4430-196 Vila Nova de Gaia')}`"
            allowfullscreen="allowfullscreen" frameborder="0" height="350"
            style="border:0" width="100%"></iframe>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Contacto",
  metaInfo: {
    title: 'Contactos',
  },
  data() {
    return {
      name: '',
      email: '',
      msg: '',
    }
  },
  methods: {
    submit() {
      axios.post('/contact', {name: this.name, email: this.email, msg: this.msg})
          .then(rsp => alert(rsp.data.msg))
          .catch(err => alert(Object.values(err.response.data.errors).join('\n')))
    }
  },
  mounted() {
    this.$parent.image = '/images/contactos.jpg';
  }
}
</script>

<style scoped>
#main input,
#main textarea {
  border: none;
  border-bottom: 1px solid #fff;
  border-radius: 0;
  background: transparent;
  color: #fff;
  padding-bottom: 5px;
  margin: 15px 0;
}

#send-btn {
  border: none !important;
  background: transparent !important;
  color: #fff;
  padding: 5px;
  font-size: 1rem;
}

#info img {
  height: 40px;
}
</style>